<top-banner variant="small"></top-banner>

<div class="main-content">
  <div class="row animated fadeIn">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body mb-2">
          <card-section-header
              title="Site Forms"
              icon="fas fa-file-alt">
          </card-section-header>
          <br>
          <div class="form-group site-forms">
            <h6>Form Name</h6>
            <input type="text" class="form-control" [(ngModel)]="formName"  style="width: 33%; margin: 0 0 60px;"/>
          </div>

          <div class="form-group site-forms" *ngIf="!isSiteOwner && !isEditExistingForm && siteOwners.length">
            <h6>Site Owner</h6>
            <p-dropdown
                class="form-control"
                [ngStyle]="{'width': '33%', 'margin': '0 0 60px'}"
                [(ngModel)]="siteOwner"
                [ngModelOptions]="{standalone: true}"
                [options]="siteOwners"
                [style]="{'width':'100%'}"
                filter="true"
            ></p-dropdown>
          </div>

          <div class="d-flex justify-content-end gap">
            <!--  -->
            <!-- left -->
            <!--  -->
            <div style="flex: 1 1;">
              <h6>Form Elements</h6>
              <p>Drag and drop these to the draft area to construct a form</p>

              <div class="site-forms section-box section-box-source d-flex flex-column">
                Input fields
                <div class="fe-source-container" dragula="FORM_CREATOR" [(dragulaModel)]="sourceFieldsInput" id="source">

                  <ng-container *ngFor="let item of sourceFieldsInput; let i = index">

                    <div class="site-forms form-element-card fe-source" [attr.style]="'--cardorder: ' + i  | safestyle" [attr.data-nestable]="item['fields'] === undefined ? 'true' : 'false'" [attr.data-container-type]="item['fields'] !== undefined ? 'true' : 'false'">
                      <div class="fe-header">
                        {{ frontendOnlySourceFieldTypeLabel[item.type] }}
                      </div>
                    </div>
                  </ng-container>
                </div>

                Informational
                <div class="fe-source-container" dragula="FORM_CREATOR" [(dragulaModel)]="sourceFieldsInformational" id="source">

                  <ng-container *ngFor="let item of sourceFieldsInformational; let i = index">

                    <div class="site-forms form-element-card fe-source fe-orange" [attr.style]="'--cardorder: ' + i  | safestyle">
                      <div class="fe-header">
                        {{ frontendOnlySourceFieldTypeLabel[item.type] }}
                      </div>
                    </div>
                  </ng-container>
                </div>

                <!-- todo add image upload -->
                Attachments
                <div class="fe-source-container" dragula="FORM_CREATOR" [(dragulaModel)]="sourceFieldsAttachment" id="source">

                  <ng-container *ngFor="let item of sourceFieldsAttachment; let i = index">

                    <div class="site-forms form-element-card fe-source fe-purple" [attr.style]="'--cardorder: ' + i  | safestyle">
                      <div class="fe-header">
                        {{ frontendOnlySourceFieldTypeLabel[item.type] }}
                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>

            <!--  -->
            <!-- middle -->
            <!--  -->
            <div style="flex: 3 3;">
              <h6>Draft</h6>

              <div class="site-forms section-box section-box-draft" style="flex: 3;" dragula="FORM_CREATOR" [(dragulaModel)]="destinationFields">
                <ng-container *ngFor="let item of destinationFields">
                  <ng-template *ngTemplateOutlet="dynamicFormField; context: {$implicit: item, parent: destinationFields}"></ng-template>
                </ng-container>
              </div>

              <div *ngIf="validationErrors.length" class="validation-box text-danger">
                Please fix the following validation problems to continue:
                <div *ngFor="let validationError of validationErrors">- {{validationError.message}}</div>
              </div>
            </div>

            <!--  -->
            <!-- right -->
            <!--  -->
            <div style="flex: 2 2;" class="site-forms">
              <h6>PREVIEW</h6>
              <p>This is how the form will appear on the Skylark app when it is being filled out</p>
              <site-forms-preview [formFields]="destinationFields"></site-forms-preview>
            </div>
          </div>

        </div>

        <div class="card-footer">
          <div>
            <button type="button" [disabled]="isSubmitting" (click)="submitForm()" class="btn btn-round float-right btn-sm btn-success">Save Form</button>
          </div>
          <button class="btn btn-sm btn-simple" (click)="openDialog()"><i class="fa fa-cog"></i></button>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #dynamicFormField let-item let-parent="parent">

  <div class="site-forms form-element-card" [ngClass]="item.category === 'informational' ? 'fe-orange' : item.category === 'attachment' ? 'fe-purple' : ''" [attr.data-nestable]="item['fields'] === undefined ? 'true' : 'false'" [attr.data-container-type]="item.fields !== undefined ? 'true' : 'false'">
    <div class="fe-header">
      {{ frontendOnlySourceFieldTypeLabel[item.type] }}
      <button type="button" class="close" aria-label="Close" (click)="removeFormElement(item, parent)"><span class="pi pi-times"></span></button>
    </div>

    <div class="fe-content">
      <!-- Headers, Text fields, Textareas, Date field, Time field -->
      <input *ngIf="item.label !== undefined" type="text" class="form-control" placeholder="Question" [(ngModel)]="item.label" />
      <input *ngIf="item.text !== undefined" type="text" class="form-control" placeholder="Text" [(ngModel)]="item.text" />
      <textarea *ngIf="item.textarea !==undefined" [(ngModel)]="item.textarea"></textarea>

      <ng-container *ngIf="item.required !== undefined">
        <p-checkbox [(ngModel)]="item.required" class="form-control checkbox" label="Required?" binary="true"></p-checkbox>
      </ng-container>

      <!-- Radio buttons -->
      <ng-container *ngIf="item.type === 'radioButton'">

        <label>Options:</label>
        <ng-container *ngFor="let option of item.options;let index = index;trackBy:trackByIndex;" >
          <div class="d-flex align-items-baseline">
            <input type="text" class="form-control" [(ngModel)]="item.options[index]" placeholder="Option {{index + 1}}"/>
            <button type="button" class="close" aria-label="Close" (click)="removeMultipleChoiceOption(item, index)"><span class="pi pi-times"></span></button>
          </div>
        </ng-container>
        <button class="btn btn-secondary btn-sm" style="width: 100%;" (click)="addMultipleChoiceOptionTo(item)">Add</button>
      </ng-container>

      <!-- Checkbox List -->
      <ng-container *ngIf="item.type === 'checkboxList'">

        <label>Options:</label>
        <ng-container *ngFor="let option of item.options;let index = index;trackBy:trackByIndex;" >
          <div class="d-flex align-items-baseline">
            <input type="text" class="form-control" [(ngModel)]="item.options[index]" placeholder="Option {{index + 1}}"/>
            <button type="button" class="close" aria-label="Close" (click)="removeMultipleChoiceOption(item, index)"><span class="pi pi-times"></span></button>
          </div>
        </ng-container>
        <button class="btn btn-secondary btn-sm" style="width: 100%;" (click)="addMultipleChoiceOptionTo(item)">Add</button>
      </ng-container>

      <!-- Table form -->
      <ng-container *ngIf="item.type === 'table'">
        A table presents the user with a smaller form for each row
        <div class="site-forms-table-draft" dragula="FORM_CREATOR" id="container-type" [(dragulaModel)]="item.fields">
          <ng-container *ngFor="let subField of item.fields">
            <ng-template *ngTemplateOutlet="dynamicFormField; context: {$implicit: subField, parent: item.fields}"></ng-template>
          </ng-container>
        </div>
      </ng-container>

    </div>
  </div>
</ng-template>


<p-dialog header="Edit directly" [(visible)]="isDialogOpen" modal="true" [style]="{'min-width': '600px'}">
  <div class="form-group">
    <label>Form data</label>
    <textarea style="min-height: 300px" type="text" class="form-control" [ngModel]="destinationFields | json" (ngModelChange)="updateJsonDirectly($event)" ></textarea>
  </div>
  <div *ngIf="jsonError" class="alert alert-danger">
    Invalid json array
  </div>
  <button type="button" (click)="isDialogOpen = false" class="btn btn-sm btn-default">Close</button>
</p-dialog>
